import React from 'react';

import type { Section } from '../../../../../models';
import { ELECTRICITY } from '../../../../../constants';
import UtilitiesOwnRentalPropertyAnnualCosts from './UtilitiesOwnRentalPropertyAnnualCosts';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ElectricityOwnRentalPropertyAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesOwnRentalPropertyAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={ELECTRICITY.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Electricity"
      utilityOwnRentalPropertyYesField={ELECTRICITY.FIELD_NAME.OWN_PROPERTY_YES}
      utilityOwnRentalPropertyNoField={ELECTRICITY.FIELD_NAME.OWN_PROPERTY_NO}
      knowAnnualCostsSimilarRentalUnitField={ELECTRICITY.FIELD_NAME.KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT}
    />
  );
}

export default ElectricityOwnRentalPropertyAnnualCosts;
